import React, { useState } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom'


const AdminProfile = ({ setPageKey }) => {
   
    const history = useHistory();

    const location = useLocation();
    const logins = location.state.login_info
    const key = location.state.key
    //console.log(key, 'key')
    //console.log(logins)
    const [re_pagekey, setRe_pagekey] = useState('')
    const [tlfNumber, setTlfNumber] = useState(logins.Phone);
    const [name, setName] = useState(logins.Name);
    const [email, setEmail] = useState(logins.EMail)
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const current_password = sessionStorage.getItem('pw')
    const isValidName = /^[a-z ,.'-]+$/i

    const [error, setError] = useState(false)
    const [nameError, setNameError] = useState('')
    const [numberError, setNumberError] = useState('')
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [noPasswordMatch, setNoPasswordMatch] = useState()

    const validateName = (e) => {
        if (e.target?.value && e.target.value.match(isValidName)) {
            setName(e.target.value)

        }
    }
    function handleNameChange(e) {
        validateName(e)
        setName(e.target.value)
        setNameError('')
        setError('')

    }

    function handleNumberChange(e) {
        const value = e.target.value.replace(/\D/g, "");
       // console.log(value)
        setTlfNumber(value);
        setNumberError('')
        setError('')
    }

    function handlePasswordChange(e) {
        setPassword(e.target.value)
        setPasswordError('')
        setPasswordRepeatError('')
        setError('')
    }

    function handleRepeatPasswordChange(e) {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')
        setError('')
    }

    function handleSubmit() {
        if (name === '' || tlfNumber === '' || password === '' || passwordRepeat === '') {
            setError(true)
        }
        if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('adgangskode matcher ikke')

        }
        if (password.length && passwordRepeat.length && password === passwordRepeat) {
            setNoPasswordMatch('')
            setError(false)
        }
        if (name === '') {

            setNameError('udfyld venligst navn')
        }
        if (tlfNumber === '') {
            setNumberError('udfyld venligst telefonnummer')
        }
        if (password === '') {
            setPasswordError('udfyld venligst adgangskode')
        }
        if (password.length && passwordRepeat === '') {
            setPasswordRepeatError('udfyld veligst adgangskode igen')
        }
        if (name.length && !name.match(isValidName)) {
            setNameError('kun bogstav i navnet')
        }

        if (tlfNumber !== '' && tlfNumber.length !== 8) {
            setNumberError('nummeret er forkert')
        }

        else if (name.length && name.match(isValidName) && tlfNumber.length === 8 ) { 
        fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/Save?Key=${key}&Email=${email}&Password=${password}&Name=${name}&Phone=${tlfNumber}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then(result => {
              //  console.log(result, 'result')
                if (result.result === 1) {
                    setPageKey('a')
                    history.push('/profile', {
                        login_info: result.login,
                        transaction: result.transactionsPrYear[0],
                        newsgroup: result.Newsgroups,
                        reservations: result.Reservations,
                        key: result.key
                    })
                }
            })

        }
    }


    function deleteProfile() {

    }

    return (
        <main>

            <p className='profile-title'>Administrer profil</p>
            <div className='login' style={{marginTop:'20px'} }>
                <label className='email-label'>Email</label>
                <input className='email-input' value={ email} />
                <label>Navn</label>
                <input type='text' value={ name} onChange={handleNameChange}></input>
                <label>Telefonnummer</label>
                <input maxLength='8' type='text' placeholder='Indtast telefonnummer' onChange={handleNumberChange} value={tlfNumber}></input>
                {/*<label> Nuværende adgangskode</label>*/}
                {/*<input className='password' type='password' value={ current_password }></input>*/}
                <label> Ny adgangskode</label>
                <input className='password' type='password' onChange={handlePasswordChange}></input>
                <label>Gentag ny adgangskode</label>
                <input type='password' onChange={handleRepeatPasswordChange}></input>
                <button type="submit" className='send_btn' onClick={handleSubmit}>Gem profiloplysninger</button>
                {error === true ?
                    <div className='error-div'>
                        {nameError && <span>{nameError}</span>}
                        {numberError && <span>{numberError}</span>}
                        {passwordError && <span>{passwordError}</span>}
                        {passwordRepeatError && !passwordError && <span>{passwordRepeatError}</span>}
                        {noPasswordMatch && <span>{noPasswordMatch}</span>}
                    </div> : null}
                <button className='delete-profile' onClick={deleteProfile }>Slet profil</button>
            </div>

        </main>
    )
}

export default AdminProfile